
import Monero from "../../../assets/duotone/Monero.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MoneroIcon({ className, dataTestid = "MoneroIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Monero data-testid={dataTestid} className={classes} {...rest} />
  );
}
